import React from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { logout } from "../features/userSlice";
import Avatar from "../images/Avatar.png";
import Global from "../Global";
import { Navigate } from "react-router-dom";

export default function Perfil({ username }) {
  const thisUser = useSelector((state) => state.user.username);
  const url = Global.url;
  const dispatch = useDispatch();

  const [posts, setPosts] = useState([]);
  const [user, setUser] = useState([]);
  const [description, setDescription] = useState("");
  const [redirect, setRedirect] = useState(false);

  //fetch data from the API

  const getPosts = async () => {
      const res = await fetch(`${url}/posts`);
      const data = await res.json();
      const myPosts = data.articles.filter((post) => post.author === username);
      setPosts(myPosts);
  };

  const getUser = async () => {
      const res = await fetch(`${url}/accounts`);
      const data = await res.json();
  
      //encontrar mi username
  
      const myUser = data.find((user) => user.username === username);

      setUser(myUser);

      try {
        const prueba = myUser.description;
      } catch (error) {
        setRedirect(true);
      }

  };

  const updateUser = async () => {
    try {
      await fetch(`${url}/accounts/${user._id}/update`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          description: description,
        }),
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      updateUser();
    }
  };

  const handleClickLogout = () => {
    dispatch(logout());
  };

  useEffect(() => {
    getUser();
    getPosts();
  }, []);

  if(redirect){
    return <Navigate to="/" />
  }

  return (
    <div className="perfil">
      <div className="section1">
        <div className="img-container">
          <img src={Avatar} alt="Foto de Porunga" />
        </div>
        <div className="info-container">
          <h1 className="username">{username}</h1>
          {thisUser === username ? (
            <form>
              <textarea
                className="description"
                defaultValue={user.description}
                onChange={(e) => setDescription(e.target.value)}
                onKeyPress={(e) => {
                  handleEnter(e);
                }}
              />
            </form>
          ) : (
            <form>
              <textarea
                className="description"
                defaultValue={user.description}
                disabled
              />
            </form>
          )}

          <br />
        </div>
        {thisUser === username ? (
          <NavLink to="/authors/null">
            <button onClick={handleClickLogout} className="btn btn-danger" id="logout">
              Logout
            </button>
          </NavLink>
        ) : null}
      </div>
      <div className="section2 pt-5 pb-5">
        <h1 className="anecdotes-lenght">
          {posts.length} { posts.length > 1 || posts.length === 0  ? "Anecdotes" : "Anecdote"}
        </h1>
        <br />
        <hr className="text-white mt-5" />
        {posts.map((post, index) => (
          <NavLink
            key={index}
            className="post-list  text-decoration-none border-0"
            to={`/posts/${post._id}`}
          >
            <h3 className="mb-5 p-5">{post.title}</h3>
            <hr />
          </NavLink>
        ))}
        {thisUser === username ? (
          <NavLink to="/create" className={"text-decoration-none"}>
            <h3 className="mas">+</h3>
          </NavLink>
        ) : null}

        <hr />
      </div>
    </div>
  );
}
